import React from "react";
import { Tooltip } from "@mui/material";
import download from "./resources/download.png";
import editSvg from "./resources/editSvg.svg";
import deleteSvg from "./resources/deleteSvg.svg";
import multiforwarder from "./resources/multiforwarder.png";
import Box from "@mui/material/Box";
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Button } from "@deere/fuel-react";

export const CustomTooltip = (title, fill, d) => {
  return (
    <span className=" !text-center ">
      <Tooltip title={title}>
        <svg height="24" width="24" viewBox="0 0 50 50">
          <path fill={fill} d={d} />
        </svg>
      </Tooltip>
    </span>
  );
};

export const CustomToolTipMulti = () => {
  return (
    <span className="custom-box">
      <Tooltip title="Multiple Forwarder Order">
      <Box component="img" sx={{ height: "35px", width: "35px" }} src={multiforwarder} />
      </Tooltip>
    </span>
  );
};

export const CustomToolTipDownload = () => {
  return (
    <span>
      <Tooltip title="Download">
        <Box component="img" sx={{ height: 24, width: 24 }} src={download} />
      </Tooltip>
    </span>
  );
};

export const CustomToolTipEditIcon = (props) => {
  return (
    <span className="text-xs w-max flex text-jd-green-primary">
      <Tooltip title={props.title}>
        <div className="flex flex-col items-center">
          <Box component="img" sx={{ height: 20, width: 20}} src={editSvg} />
        </div>
      </Tooltip>
      &nbsp;
    </span>
  );
};

export const CustomToolTipDeleteIcon = () => {
  return (
    <span className="text-xs w-max flex text-danger">
      <Tooltip title="Delete Quote">
        <div className="flex flex-col items-center">
          <Box component="img" sx={{ height: 20, width: 20}} src={deleteSvg} />
        </div>
      </Tooltip>
      &nbsp;
    </span>
  );
};

export const GenericButton = (text) => {
  return (
    <span className="text-xs w-max flex text-jd-green-primary">
      <Button 
        variant="primary" 
        size="small"
        style={{
          paddingLeft: "3px", 
          paddingRight: "3px",
          paddingTop: "1px", 
          paddingBottom: "1px",
          fontSize: "12px"
        }}
      >
        <label className="text-xs">Approve</label>
      </Button>
    </span>
  );
};

export const CustomToolTipUrgentOrders = (props) => {
  return (
    <span className="custom-box">
      <Tooltip title={props.data}>
        <RocketLaunchRoundedIcon className="text-blue-500" />
      </Tooltip>
    </span>
  );
};

export const CustomToolTipReport = (props) => {
  return (
      <Tooltip title={props.title}>
        <UpdateRoundedIcon className="text-blue-500" />
      </Tooltip>
  );
};
